import { render } from "./AddFactureSPage.vue?vue&type=template&id=7779203e&ts=true"
import script from "./AddFactureSPage.vue?vue&type=script&lang=ts"
export * from "./AddFactureSPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__